/**
 * Canonical help-video id registry — the single source of truth the SERVER
 * trusts when validating a help-center analytics event (batch 5 of the July
 * 2026 design handoff).
 *
 * The rich registry (groups, titles, subs, durations, tones, availability, and
 * the video/poster src helpers) lives in the web app at
 * apps/web/src/lib/helpVideos.ts. The API cannot import from apps/web, so the
 * bare id list is duplicated here. A unit test in the web app
 * (apps/web/src/lib/help.shared.test.ts) asserts the web HELP_VIDEOS registry
 * ids exactly match this array, so the two can never silently drift.
 *
 * Order mirrors the design handoff's CF_HELP_VIDEOS order (grouped: Getting
 * started → Your practice → Cosmic features).
 */
export const HELP_VIDEO_IDS = [
  "first-pull",
  "birth-data",
  "moon-basics",
  "journal",
  "ceremonies",
  "sharing",
  "decks",
  "themes",
  "billing",
] as const;

export type HelpVideoId = (typeof HELP_VIDEO_IDS)[number];

const HELP_VIDEO_ID_SET = new Set<string>(HELP_VIDEO_IDS);

/** Type guard: is `value` one of the registered help-video ids? */
export function isHelpVideoId(value: unknown): value is HelpVideoId {
  return typeof value === "string" && HELP_VIDEO_ID_SET.has(value);
}
